import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { selectMenu } from '@app/store/actions';
import { IMenuItem, SidebarItemComponent } from '@app/components';
import { hasMenuPermissionChild } from '@app/helpers/permissions';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTooltip } from '@app/componentsV2';

interface IProps {
    menuItem: IMenuItem;
    setIsCollapsed: (isCollapsed: boolean) => void;
    isCollapsed: boolean;
}

export const SidebarAccordionComponent = (props: IProps) => {
    const [isOpened, setIsOpened] = useState(false);
    const openedMenuId = useSelector((state: any) => state.sidebar.menuId);
    const dispatch = useDispatch();
    const activeMenuParentId = useSelector((state: any) => state.sidebar.activeMenuParentId);

    const { translation } = useTypedTranslation();

    const { menuItem, setIsCollapsed, isCollapsed } = props;

    useEffect(() => {
        setIsOpened(true);
    }, [openedMenuId]);

    const submenuToggle = (id: number) => (): void => {
        if (isCollapsed) {
            setIsCollapsed(false);
        }

        dispatch(selectMenu(id));
        setIsOpened(!isOpened);
    };

    const accordionClass = (isOpened: boolean): string => {
        let classes: string = 'sidebar__item accordion';
        classes = activeMenuParentId === menuItem.id ? (classes += ' sidebar__item--active') : classes;

        return isOpened && openedMenuId === menuItem.id ? (classes += ' accordion--opened') : classes;
    };

    return (
        <>
            {menuItem.children !== undefined && (
                <>
                    {isCollapsed ? (
                        <PasslyTooltip title={translation(menuItem.name)} placement='right' disableHoverListener={!isCollapsed}>
                            <Button className={accordionClass(isOpened)} onClick={submenuToggle(menuItem.id)}>
                                <div className='sidebar__item-icon'>
                                    <i className={`icon-${menuItem.icon}`} aria-hidden='true' />
                                </div>
                                <div className='sidebar__item-name'>{translation(menuItem.name)}</div>
                                <div className='accordion__arrow'>
                                    <i className='icon-arrow-right' aria-hidden='true' />
                                </div>
                            </Button>
                        </PasslyTooltip>
                    ) : (
                        <Button className={accordionClass(isOpened)} onClick={submenuToggle(menuItem.id)}>
                            <div className='sidebar__item-icon'>
                                <i className={`icon-${menuItem.icon}`} aria-hidden='true' />
                            </div>
                            <div className='sidebar__item-name'>{translation(menuItem.name)}</div>
                            <div className='accordion__arrow'>
                                <i className='icon-arrow-right' aria-hidden='true' />
                            </div>
                        </Button>
                    )}

                    <div className='sidebar__submenu'>
                        {isOpened && !isCollapsed && openedMenuId === menuItem.id
                            ? menuItem.children.map((menuSubItem: IMenuItem, index: number) => {
                                  if (!menuSubItem.requiresPermission || hasMenuPermissionChild(menuSubItem)) {
                                      return <SidebarItemComponent key={index} item={menuSubItem} />;
                                  } else {
                                      return null;
                                  }
                              })
                            : null}
                    </div>
                </>
            )}
        </>
    );
};
